<template>
  <div id="table" :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">
    <div style="width: 85%" class="table-btn-container">
      <div style="height: 125px" class="d-flex align-center justify-center">
        <div @click="handleResponsive" :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'button']">
          <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{btn}}</div>
          <div class="px-5 arrow-btn"><img src="../../assets/icons/down-arrow.svg"></div>
        </div>
      </div>
    </div>
    <template>
      <div class="wrapper w-100">
        <div class="inner w-100">
          <div class="table-container">
            <div class="table-header">
              <div :class="[this.$lang === 'ar' ? 'flex-direction' : '', 'header-inner-container']">
                <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'titles']">{{$t('products.table.tableTitle')}}</div>
                <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'check-box-container']" >
                  <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', '']">
                    <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'check d-flex align-items-center justify-center px-5']">
                      <input class="d-none" type="radio" v-model="checked" id="dealer" name="filter" value="0">
                      <div @click="checked = 0" class="checkbox-element">
                        <div v-if="checked == 0" class="checked position-relative">
                          <div class="black-shadow"></div>
                        </div>
                      </div>
                      <label :class="[this.$lang === 'ar' && checked == 0 ? 'bold-italic-ar' : checked == 0 ? 'bold-italic-en' : '', 'px-2']" for="dealer">{{$t('products.table.dealers')}}</label>
                    </div>
                    <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'check d-flex align-items-center justify-center']">
                      <input class="d-none" type="radio" id="service" v-model="checked" name="filter" value="1">
                      <div @click="checked = 1" class="checkbox-element">
                        <div v-if="checked == 1" class="checked position-relative">
                          <div class="black-shadow"></div>
                        </div>
                      </div>
                      <label :class="[this.$lang === 'ar' && checked == 1 ? 'bold-italic-ar' : checked == 1 ? 'bold-italic-en' : '', 'px-2']" for="service">{{$t('products.table.service')}}</label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="custom-table ">
              <div :class="[this.$lang === 'ar' ? 'bold-italic-ar flex-row-reverse' : 'bold-italic-en', 'custom-table-header d-flex']">
                <div :class="[lang === 'ar' ? 't-border-ar' : 't-border-en', 't-head d-flex align-items-center justify-center ']"><div>{{$t('products.table.charging')}}</div></div>
                <div :class="[lang === 'ar' ? 't-border-ar' : 't-border-en', 't-head d-flex align-items-center justify-center ']"><div>{{$t('products.table.price')}}</div></div>
              </div>
              <div :style="items.length === 0 && {height: '300px'}" :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'custom-table-body']">
                <div v-if="loader" style="height: 300px; display: flex; align-items: center; justify-content: center; flex-direction: column">
                  <loader />
                </div>
                <Error v-if="error" />
                <div :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex t-item-container']" v-for="item in items" :key="item.id">
                  <div :class="[lang === 'ar' ? 't-border-ar' :'t-border-en', 't-item d-flex align-items-center justify-center']"> <div> {{item.unit}} </div></div>
                  <div :class="[lang === 'ar' ? 't-border-ar' :'t-border-en', 't-item d-flex align-items-center justify-center']"><div>{{item.price}} </div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-container">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalElements"
              :per-page="perPage"
              aria-controls="lines-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import $ from 'jquery'
import UnitRepository from '../../repositories/UnitRepository'
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
export default {
  components: { Loader, Error },
  props: {
    data: Array
  },
  data () {
    return {
      lang: this.$lang,
      perPage: 6,
      currentPage: 1,
      items: [],
      show: false,
      btn: this.$t('products.table.showBtn'),
      checked: 0,
      unitRepo: new UnitRepository(),
      totalElements: 0,
      loader: false,
      error: false,
      allData: []
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  },
  created () {
    this.getData()
  },
  watch: {
    async currentPage (val) {
      this.items = []
      this.loader = true
      const page = val - 1
      try {
        const response = await this.unitRepo.getWithPagination(this.checked, page, this.perPage)
        if (response.data.status === 200) {
          this.items = []
          if (page === this.currentPage - 1) {
            for (let i = 0; i < response.data.data.data.length; i++) {
              this.items.push(response.data.data.data[i])
            }
            this.totalElements = response.data.data.totalElements
          } else {
            return
          }
        } else {
        }
      } catch (e) {
        console.log(e)
      }
      this.loader = false
    },
    checked (val) {
      this.loader = false
      this.error = false
      this.items = []
      this.totalElements = 0
      this.currentPage = 1
      this.getData()
    }
  },
  methods: {
    handleResponsive () {
      if (!this.show) {
        $('#table .wrapper').addClass('is-open')
        // setTimeout(() => {
        //   $('#table .inner').css('overflow', 'visible')
        // }, 300)
        this.show = true
        this.btn = this.$t('products.table.hideBtn')
        $('#table .arrow-btn').addClass('rotate')
      } else {
        $('#table .wrapper').removeClass('is-open')
        // $('#table .inner').css('overflow', 'hidden')
        this.show = false
        this.btn = this.$t('products.table.showBtn')
        $('#table .arrow-btn').removeClass('rotate')
      }
    },
    async getData () {
      this.loader = true
      const page = this.currentPage - 1
      try {
        const response = await this.unitRepo.getWithPagination(this.checked, page, this.perPage)
        if (response.data.status === 200) {
          this.items = []
          for (let i = 0; i < response.data.data.data.length; i++) {
            this.items.push(response.data.data.data[i])
          }
          this.totalElements = response.data.data.totalElements
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.loader = false
    }
  }
}
</script>
<style lang="scss" scoped>
.black-shadow {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  position: absolute;
  z-index: -1;
  background: rgba(0,0,0);
  filter: blur(2px);
  bottom: -2px;
  right: -2px;
}
label{
  cursor: pointer;
}
.flex-direction{
  flex-direction: row-reverse;
}
.table-container {
  width: 85%;
  //min-height: 250px; // for loader button handle
  border-radius: 30px;
  box-shadow: 15px 15px 40px rgba(0,0,0,.03), -15px -15px 40px rgba(0,0,0,.03);
  //box-shadow: 15px 15px 40px rgba(0,0,0,.03);
  margin: 0px auto;
  //margin-top: 30px; // able to remove
  border: 2.5px solid rgba(255,255,255,1);
}
.check{
  cursor: pointer;
  label{
    font-size: 12px;
  }
}
.checkbox-element{
  height: 18px;
  width: 18px;
  border: 2px solid #FFCB05;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checked{
  height: 10px;
  width: 10px;
  background: #FFCB05;
  border-radius: 50%;
}
.arrow-btn{
  transition: transform .3s ease-in-out;
  img{
    height: 15px;
    width: 15px
  }
}
.rotate {
  transform: rotate(180deg);
}
#table{
  min-height: 125px;
  background: linear-gradient(to bottom, rgba(255,255,255,.8), rgba(255,255,255,.4));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .button{
    width: 280px;
    height: 55px;
    border: 3px solid #FFCB05;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.table-header{
  width: 100%;
  height: 70px;
  background: rgba(242,242,242,.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #383838;
  //border-top: 3px solid rgba(255,255,255,.7) ;
  //border-left: 3px solid rgba(255,255,255,.7) ;
  //border-right: 3px solid rgba(255,255,255,.7);
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  .titles{
    font-size: 15px;
  }
  .header-inner-container{
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }
}
form {
  display: flex;
}
.wrapper{
  //display: grid;
  //grid-template-rows: 0fr;
  transition: all .3s ease-in-out;
  height: 0px;
  //opacity: 0;
}
.inner {
  //overflow: hidden;
  margin: 0 auto;
}
.is-open{
  //grid-template-rows: 1fr;
  height: 544.8px;
  //opacity: 1;
}
.custom-table {
  //border: 3px solid rgba(255,255,255, .5);
  background: rgb(227,227,227, 0.8);
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  //height: 350px;
}
.custom-table-header {
  height: 60px;
}
.custom-table-body{
  height: 300px;
}
.t-border-en:first-child{
  border-right: 2.5px solid rgba(255,255,255,.3);
}
.t-border-ar:first-child{
  border-left: 2.5px solid rgba(255,255,255,.3);
}
.t-head{
  font-size: 14px;
  width: 50%;
  height: 100%;
  align-self: center;
  background: #FFCB05;
}
.t-item{
  width: 50%;
  height: 50px;
  border-bottom: 2.5px solid rgba(255,255,255,.3);
}
.t-item-en{
  border-right: 2.5px solid rgba(255,255,255,.3);
}
.t-item-ar{
  border-left: 2.5px solid rgba(255,255,255,.3);
}
.t-item-en:last-child{
  border-right: none;
}
.t-item-ar:last-child{
  border-left: none;
}
.t-item-container {
  padding: 0 30px;
}
.t-item-container:last-child > .t-item{
  border-bottom: none;
}
@media screen and (max-width: 900px) {
  .table-header{
    height: 95px;
  }
  .header-inner-container{
    flex-direction: column;
    justify-content: center !important;
    height: 90px;
  }
  form {
    align-items: center;
    justify-content: center;
    margin: 10px 0 0 0;
  }
  .check{
    padding: 0 !important;
  }
  .is-open{
    //grid-template-rows: 1fr;
    height: 569.8px;
    //opacity: 1;
  }
}
@media (max-width: 500px) {
  .button{
    width: 250px !important;
  }
  .t-item-container {
    padding: 0 15px;
  }
  .header-inner-container{
    width: 95% !important;
  }
  .table-container{
    width: 90% !important;
  }
  .check{
    min-width: 90px;
  }
}
</style>
<style lang="scss">
#table{
  /*--------------- pagination -----------------------*/
  span.page-link {
    background: transparent !important;
    padding: 0;
    border: none;
  }
  .pagination-container{
    background: #FFFFFF;
    height: 70px;
    width: 100%;
    margin-top: 40px;
  }
  ul.pagination.b-pagination{
    width: 50%;
    padding: 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
  }
  li:first-child,
  li:last-child{
    display: none;
  }
  li:nth-child(2),
  li:nth-last-child(2) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    span.page-link,
    button.page-link{
      padding: 0 0 2px 0 !important;
      display: block;
      background: transparent;
      color: black;
      border: 3px solid #FFCB05;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  button.page-link:focus,
  span.page-link{
    outline: none !important;
  }
  li.page-item.active:focus{
    outline: none !important;
    border:none !important;
  }
  button.page-link,
  .page-link.active, .active > .page-link{
    background: transparent;
    border: none;
    color: #d3d3d3;
    font-size: 14px;
  }
  .page-link.active, .active > .page-link{
    color: #FFCB05;
  }
}
@media screen and (max-width: 900px) {
  ul.pagination.b-pagination{
    width: 70% !important;
  }
}
</style>
